import { CATALOGS, displayName, hasTags, useRegistry } from "../registry";
import type { TagSet } from "../types";

const CATALOG_CLASS: Record<string, string> = {
  features: "badge-primary",
  hardware: "badge-secondary",
  software: "badge-accent",
  programs: "badge-info",
};

/** Registry tags as small badges, with the key and catalog on hover. */
export default function TagChips({
  tags,
  source,
  empty,
}: {
  tags: TagSet | undefined;
  /** "spec" tags are declared by the spec; "derived" ones were guessed from its name. */
  source?: string | null;
  /** Text shown when there are no tags (omit to render nothing). */
  empty?: string;
}) {
  const { data: registry } = useRegistry();
  if (!tags || !hasTags(tags)) {
    return empty ? <span className="text-xs opacity-50">{empty}</span> : null;
  }
  const derived = source === "derived";
  const note = derived
    ? " · derived from the spec name"
    : source === "spec"
      ? " · declared by the spec"
      : "";
  return (
    <span className="inline-flex flex-wrap gap-1 items-center">
      {CATALOGS.flatMap(({ field, label }) =>
        tags[field].map((key) => (
          <span
            key={`${field}:${key}`}
            className={`badge badge-sm badge-outline bg-base-100 ${CATALOG_CLASS[field]}`}
            title={`${label} · ${key}${note}`}
          >
            {displayName(registry, key)}
          </span>
        )),
      )}
      {derived && <span className="text-[10px] uppercase tracking-wide opacity-50">derived</span>}
    </span>
  );
}
